import { TOOL_LINKS } from "@/config/links";
import type { OrgToolLinksStored } from "@/lib/locationToolLinks";

export function draftWithBaseUrl(prev: OrgToolLinksStored, linkId: string, baseUrl: string): OrgToolLinksStored {
  return {
    ...prev,
    byId: {
      ...prev.byId,
      [linkId]: { ...prev.byId[linkId], baseUrl },
    },
  };
}

export function draftWithOverride(
  prev: OrgToolLinksStored,
  linkId: string,
  locationId: string,
  url: string
): OrgToolLinksStored {
  const tmpl = TOOL_LINKS.find((t) => t.id === linkId);
  const cur = prev.byId[linkId] ?? { baseUrl: tmpl?.baseUrl ?? "" };
  const nextPer = { ...(cur.perLocation ?? {}) };
  if (!url.trim()) delete nextPer[locationId];
  else nextPer[locationId] = url.trim();
  return {
    ...prev,
    byId: {
      ...prev.byId,
      [linkId]: {
        ...cur,
        baseUrl: cur.baseUrl,
        perLocation: Object.keys(nextPer).length ? nextPer : undefined,
      },
    },
  };
}

export function draftWithLinkTypeMeta(
  prev: OrgToolLinksStored,
  linkId: string,
  label: string,
  description: string
): OrgToolLinksStored {
  const defs = [...(prev.linkTypeDefs ?? [])];
  const i = defs.findIndex((d) => d.id === linkId);
  const row = { id: linkId, label, description };
  if (i >= 0) defs[i] = row;
  else if (TOOL_LINKS.some((t) => t.id === linkId) || prev.byId[linkId]) defs.push(row);
  return { ...prev, linkTypeDefs: defs.length ? defs : undefined };
}

export function draftWithNewLinkType(
  prev: OrgToolLinksStored,
  id: string,
  label: string,
  description: string
): OrgToolLinksStored {
  return {
    ...prev,
    linkTypeDefs: [...(prev.linkTypeDefs ?? []), { id, label, description }],
    byId: {
      ...prev.byId,
      [id]: { baseUrl: "" },
    },
  };
}

export function draftWithoutLinkType(prev: OrgToolLinksStored, linkId: string): OrgToolLinksStored {
  const nextBy = { ...prev.byId };
  delete nextBy[linkId];
  const defs = (prev.linkTypeDefs ?? []).filter((d) => d.id !== linkId);
  return {
    ...prev,
    byId: nextBy,
    linkTypeDefs: defs.length ? defs : undefined,
  };
}
